import axios from '../config/axios'

const getAuthToken = () => localStorage.getItem('authToken');

const addAuthTokenToHeaders = (headers = {}) => {
  if (typeof headers !== 'object' || headers === null) {
    headers = {};
  }

  const token = getAuthToken();
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
    headers['userType'] = 'admin';
  }

  return headers;
};

export const postRequest = ({ url, params, headers, data }) =>
  axios({
    method: 'POST',
    url,
    params,
    headers: addAuthTokenToHeaders(headers),
    data,
  });

export const getRequest = ({ url, params, headers }) =>
  axios({
    method: 'GET',
    url,
    params,
    headers: addAuthTokenToHeaders(headers),
  });

export const putRequest = ({ url, params, headers, data }) =>
  axios({
    method: 'PUT',
    url,
    params,
    headers: addAuthTokenToHeaders(headers),
    data,
  });

export const deleteRequest = ({ url, params, headers }) =>
  axios({
    method: 'DELETE',
    url,
    params,
    headers: addAuthTokenToHeaders(headers),
  });

export const patchRequest = ({ url, params, headers, data }) =>
  axios({
    method: 'PATCH',
    url,
    params,
    headers: addAuthTokenToHeaders(headers),
    data,
  });

  export const downloadRequest = ({ url, params, headers }) =>
  axios({
    method: 'GET',
    url,
    params,
    headers: addAuthTokenToHeaders(headers),
    responseType: "blob",
  });
